import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import React from 'react';
import sadImg from '../../assets/noTrans.svg';
import AddImg from '../../assets/FAB.svg';
import { useNavigate } from 'react-router-dom';
import backImg from '../../assets/back.svg';

const Container = styled(Box)(
   ({ theme }) => `

height: calc(100vh - ${theme.header.height}); 
	// border: 1px solid red;
				width: 100%; 
			display: flex;
			justify-content: center;
			align-items: center;
 
`
);
const Icon = styled.figure(
   ({ theme }) => `
	width: 70%; 
	margin: 6rem auto 0 auto; 
	height:30vh;
`
);
const AddIcon = styled.figure(
   ({ theme }) => `
	width: 80px;
position: absolute;
right: 1rem;
bottom: 1rem;
`
);

const NoGroup = () => {
   const navigate = useNavigate();
   return (
      <Container>
         <Box
            sx={{
               width: '90%',
               maxWidth: '615px',
               minHeight: '80vh',
               margin: '2rem auto',
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: '20px ',
               background: '#EFEEF4',
               borderRadius: '25px 25px 0 0',
            }}
         >
            <img
               src={backImg}
               alt="back"
               style={{
                  position: 'absolute',
                  width: '40px',
                  cursor: 'pointer',
               }}
               onClick={() => window.history.back()}
            />
            <Typography
               // variant='h4'
               sx={{
                  fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
                  textAlign: 'center',
                  marginTop: '1.5rem',
                  fontWeight: '600',
               }}
            >
               Groups
            </Typography>
            <Icon>
               <img
                  src={sadImg}
                  alt="No contact"
                  style={{ width: '100%', height: '100%' }}
               />
            </Icon>
            <Box
               sx={{
                  margin: '2rem auto 0 auto',
                  width: '70%',
                  textAlign: 'center',
               }}
            >
               <Typography
                  sx={{
                     fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
                     textAlign: 'center',
                     marginTop: '2rem',
                     fontWeight: '600',
                  }}
               >
                  You do not have any saved Groups yet! Click on the add button
                  to add new groups
               </Typography>
            </Box>
            <AddIcon onClick={() => navigate('/contacts/add-group')}>
               <img
                  src={AddImg}
                  alt="add contacts"
                  style={{
                     width: '100%',
                     height: '100%',
                     cursor: 'pointer',
                  }}
               />
            </AddIcon>
         </Box>
      </Container>
   );
};

export default NoGroup;
